export default
{
	INTERACTIVE: 'interactive'
};